/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationDetails {
    getFixupPrototypeFunction() { return ScheduleRecommendationDetails.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationDetails>): ScheduleRecommendationDetails {
        let obj = Object.assign(new ScheduleRecommendationDetails(), model);
        ScheduleRecommendationDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationDetails>): ScheduleRecommendationDetails {
        if (!model) return null;
        return ScheduleRecommendationDetails.newInstance(<ScheduleRecommendationDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationDetails) {
        if (!obj) return;

        models.ScheduleRecommendationDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationDetails): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.potential_cost_savings_daily === undefined) {
            this.potential_cost_savings_daily = 0;
        }
        if (this.potential_cost_savings_monthly === undefined) {
            this.potential_cost_savings_monthly = 0;
        }
        if (this.potential_cost_savings_yearly === undefined) {
            this.potential_cost_savings_yearly = 0;
        }
        if (this.savings_percentage === undefined) {
            this.savings_percentage = 0;
        }
        if (this.resources_count === undefined) {
            this.resources_count = 0;
        }
        if (this.hourly_recommendations === undefined) {
            this.hourly_recommendations = 0;
        }
        if (this.weekly_recommendations === undefined) {
            this.weekly_recommendations = 0;
        }
    }

    /**
     * Service Account Id
     */
    service_account_id: string;

    /**
     * Daily Cost Savings
     */
    potential_cost_savings_daily: number;

    /**
     * Monthly Cost Savings
     */
    potential_cost_savings_monthly: number;

    /**
     * Yearly Cost Savings
     */
    potential_cost_savings_yearly: number;

    /**
     * Potential Savings Percentage
     */
    savings_percentage: number;

    /**
     * Count of recommendations resources
     */
    resources_count: number;

    /**
     * Count of hourly recommendations
     */
    hourly_recommendations: number;

    /**
     * Count of weekly recommendations
     */
    weekly_recommendations: number;

}
